<template>
    <div>
        <div v-if="!comment && !edit">
            <div class="d-flex justify-content-between alert alert-info">
                <a
                    role="button"
                    class="tarief-intro icon-plus"
                    @click.prevent="toggleEdit"
                >
                    <span>Nieuw bericht</span>
                    <span v-if="!reply" class="alt"
                        >Plaats een bericht voor deze Rockstar</span
                    >
                    <span v-if="reply" class="alt"
                        >Reageer op het bericht van je manager</span
                    >
                </a>
            </div>
        </div>

        <div
            v-if="comment && !edit"
            class="d-flex justify-content-between alert alert-info"
        >
            <div class="col-22">
                <strong>{{ comment.name }} : </strong>
                <span>{{ comment.comment }}</span>
            </div>
            <div v-show="showEditButton" class="col-1">
                <button
                    class="btn btn-link icon-change p-0"
                    @click.prevent="toggleEdit"
                />
            </div>
            <div v-show="showDeleteButton" class="col-1">
                <button
                    class="btn btn-link icon-min p-0"
                    @click.prevent="removeMessage"
                />
            </div>
        </div>
        <form v-if="edit" class="alert alert-info edit-form edit">
            <div class="row form-group">
                <div class="col-19">
                    <label class="sr-only">Bewerk bericht</label>
                    <input
                        v-model="message"
                        class="col-24 form-control"
                        type="text"
                    />
                    <div v-if="!$v.message.maxLength" class="error-text">
                        Bericht mag niet langer zijn dan
                        {{ $v.message.$params.maxLength.max }} tekens.
                    </div>
                </div>
                <div class="col-3">
                    <button
                        type="submit"
                        class="btn btn-secondary"
                        :disabled="!$v.message.maxLength"
                        @click.prevent="saveMessage"
                    >
                        save
                    </button>
                </div>
                <div class="col-2">
                    <button
                        class="btn btn-link link-cancel"
                        @click.prevent="toggleEdit"
                    >
                        cancel
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { maxLength } from 'vuelidate/lib/validators';
import EventBus from '@/shared/VueEvent';
export default {
    name: 'RockOverviewMessage',
    props: {
        comment: {
            type: Object,
            required: false,
            default: null
        },
        showDeleteButton: {
            type: Boolean,
            required: false
        },
        showEditButton: {
            type: Boolean,
            required: false
        },
        reply: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            edit: false,
            message: this.comment && this.comment.comment
        };
    },
    validations: {
        message: {
            maxLength: maxLength(500)
        }
    },
    methods: {
        toggleEdit: function () {
            this.edit = !this.edit;
        },
        saveMessage: function () {
            this.$v.$touch();
            if (!this.$v.$error) {
                EventBus.fire('saveMessage', {
                    id: this.comment && this.comment.id,
                    comment: this.message,
                    reply: this.reply
                });
            }
        },
        removeMessage: function () {
            EventBus.fire('removeMessage', this.comment.id);
        }
    }
};
</script>
